import protobuf from 'protobufjs';
import { CancerType } from '../schema';
import { getServiceUrl } from '../utils/api';

// Define the proto JSON structure inline 
const protoDefinition = {
    nested: {
        admin: {
            nested: {
                UpdateCaseRequest: {
                    fields: {
                        case_id: { type: "string", id: 1 },
                        cancer_type: { type: "int32", id: 2 }
                    }
                },
                UpdateCaseResponse: {
                    fields: {
                        success: { type: "bool", id: 1 }
                    }
                }
            }
        }
    }
};

const root = protobuf.Root.fromJSON(protoDefinition);
const UpdateCaseRequest = root.lookupType("admin.UpdateCaseRequest");

export const updateCase = async (
    caseId: string,
    cancerType: CancerType,
    accessToken: string | null,
    setAccessToken: (token: string | null) => void,
    logout: () => Promise<void> | void
): Promise<void> => {

    // Ensure we are sending a valid integer (0 if undefined/Not Provided)
    const cancerTypeVal = cancerType || 0;

    const requestPayload = {
        case_id: caseId,
        cancer_type: cancerTypeVal
    };

    const errMsg = UpdateCaseRequest.verify(requestPayload);
    if (errMsg) throw Error(errMsg);

    const message = UpdateCaseRequest.create(requestPayload);
    const buffer = UpdateCaseRequest.encode(message).finish();

    const apiUrl = getServiceUrl('adminservice', 'updatecase');

    if (!accessToken) {
        await logout();
        throw new Error("No access token available");
    }

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-protobuf',
            'Authorization': `Bearer ${accessToken}`
        },
        body: buffer as any
    });

    if (response.status === 401) {
        await logout();
        throw new Error("Session expired. Please login again.");
    }

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update case: ${response.status} ${response.statusText} - ${errorText}`);
    }
};
